<template>
  <teleport v-if="showAiSnappingDialog" to="#model-frame-wrapper">
    <div class="top-left-corner">
      <fp-icon symbol="corner"></fp-icon>
    </div>
    <div class="bottom-left-corner">
      <fp-icon symbol="corner"></fp-icon>
    </div>
    <div class="top-right-corner">
      <fp-icon symbol="corner"></fp-icon>
    </div>
    <div class="bottom-right-corner">
      <fp-icon symbol="corner"></fp-icon>
    </div>
  </teleport>
  <div class="ai-snapping-dialog" :class="{ open: showAiSnappingDialog }">
    <!--<p>{{$t('מקם את הזווית הרצויה')}}</p>
    <button class="full-btn" type="button" @click="takeSnapshot">
      <fp-icon symbol="camera"></fp-icon>
      {{$t('צלם תצוגם AI')}}
    </button>-->
    <button class="shutter" type="button" @click="takeSnapshot">
      <fp-icon symbol="camera"></fp-icon>
    </button>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import FpIcon from "@/components/FpIcon.vue";
import cameraSound from "@/assets/sounds/camera.mp3";

export default {
  name: 'AiSnappingDialog',
  components: {FpIcon},
  computed: {
    ...mapGetters('aIAgent', ['showAiSnappingDialog'])
  },
  methods: {
    takeSnapshot(){
      const audio = new Audio(cameraSound);
      audio.play();
      this.$frameBus.emit('message', {
        action: 'takeSnapshot'
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.top-left-corner {
  position: absolute;
  top: 20px;
  left: 70px;
  z-index: 1001;
  svg {
    width: 50px;
    height: 50px;
    transform: rotate(-90deg);
    fill: var(--primary);
  }
}

.top-right-corner {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1001;
  svg {
    width: 50px;
    height: 50px;
    fill: var(--primary);
    transform: rotate(0deg);
  }
}

.bottom-left-corner {
  position: absolute;
  bottom: 20px;
  left: 70px;
  z-index: 1001;
  svg {
    width: 50px;
    height: 50px;
    fill: var(--primary);
    transform: rotate(180deg);
  }
}

.bottom-right-corner {
  position: absolute;
  bottom: 20px;
  right: 20px;
  z-index: 1001;
  svg {
    width: 50px;
    height: 50px;
    fill: var(--primary);
    transform: rotate(90deg);
  }
}

.ai-snapping-dialog {
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 12px;
  padding: 32px;
  z-index: 1001;
  display: none;

  &.open {
    display: block;
  }

  p {
    margin-bottom: 30px;
    font-size: 1.25rem;
    color: #fff;
  }

  .shutter {
    border-radius: 50%;
    background-color: white;
    border: 3px solid transparent;
    box-shadow: white 0 0 0 5px, rgba(255, 255, 255, 0.3) 0 0 0 8px;
    width: 50px;
    height: 50px;
    transition: transform 0.2s ease-in-out;

    &:hover {
      transform: scale(1.1);
    }

    svg {
      fill: var(--primary);
      stroke: var(--primary);
    }
  }

  .full-btn {
    background-color: oklch(0.715 0.143 215.221);
    color: rgb(255, 255, 255);
    box-shadow: rgba(0, 0, 0, 0) 0 0 0 0, rgba(0, 0, 0, 0) 0 0 0 0, rgba(0, 0, 0, 0) 0 0 0 0, rgba(0, 0, 0, 0) 0 0 0 0, rgba(0, 0, 0, 0.1) 0 10px 15px -3px, rgba(0, 0, 0, 0.1) 0 4px 6px -4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    white-space: nowrap;
    font-weight: 500;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
    outline: 2px solid transparent;
    outline-offset: 2px;
    border-radius: 0.375rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    width: 100%;
    height: 4rem;
    font-size: 1.25rem;
    &:hover {
      background-color: oklch(0.665 0.158 217.42);
    }

    svg {
      stroke: #fff;
      fill: #fff;
    }
  }
}
</style>